import { useState } from "react";

export const useBooleanState = (initialValue = false) => {
	const [param, setParam] = useState(initialValue);
	const setTrue = () => setParam(true);
	const setFalse = () => setParam(false);
	return [param, setTrue, setFalse];
};